module.exports = __webpack_public_path__ + "static/img/pp_advert2.0b1f9042.gif";